(() => {
  if (customElements.get('ravin-grid-gallery')) return;

  class RavinGridGallery extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-ravin-gallery-image]'));
      if (this.slides.length < 2) return;

      this.hoverTarget = this.parentElement;
      this.counter = this.hoverTarget.querySelector('[data-ravin-gallery-count]');
      this.index = 0;
      this.rotationEnabled = this.dataset.rotationEnabled === 'true';
      this.rotationSpeed = Math.max(500, (Number(this.dataset.rotationSpeed) || 0.5) * 1000);
      this.hovering = false;
      this.ignoreClickUntil = 0;
      this.touchStart = null;
      this.timer = null;

      this.onEnter = (event) => {
        if (!this.rotationEnabled || event.pointerType === 'touch') return;
        if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.hovering = true;
        this.stopRotation();
        this.timer = window.setInterval(() => {
          if (!this.isConnected || !this.hovering || document.hidden) return;
          this.showImage((this.index + 1) % this.slides.length, true);
        }, this.rotationSpeed);
      };

      this.onLeave = () => {
        this.hovering = false;
        this.stopRotation();
        this.showImage(0, false);
      };

      this.onScroll = () => {
        if (!this.clientWidth) return;
        this.index = Math.min(this.slides.length - 1, Math.max(0, Math.round(this.scrollLeft / this.clientWidth)));
        this.updateCounter();
      };

      this.onTouchStart = (event) => {
        if (event.touches.length !== 1) return;
        this.touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      };

      this.onTouchEnd = (event) => {
        if (!this.touchStart || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - this.touchStart.x;
        const dy = event.changedTouches[0].clientY - this.touchStart.y;
        if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          this.ignoreClickUntil = Date.now() + 500;
        }
        this.touchStart = null;
      };

      this.onClick = (event) => {
        if (Date.now() >= this.ignoreClickUntil) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.ignoreClickUntil = 0;
      };

      this.hoverTarget.addEventListener('pointerenter', this.onEnter);
      this.hoverTarget.addEventListener('pointerleave', this.onLeave);
      this.addEventListener('scroll', this.onScroll, { passive: true });
      this.addEventListener('touchstart', this.onTouchStart, { passive: true });
      this.addEventListener('touchend', this.onTouchEnd, { passive: true });
      this.addEventListener('click', this.onClick, true);
    }

    disconnectedCallback() {
      this.stopRotation();
      if (!this.hoverTarget || !this.onEnter) return;
      this.hoverTarget.removeEventListener('pointerenter', this.onEnter);
      this.hoverTarget.removeEventListener('pointerleave', this.onLeave);
      this.removeEventListener('scroll', this.onScroll);
      this.removeEventListener('touchstart', this.onTouchStart);
      this.removeEventListener('touchend', this.onTouchEnd);
      this.removeEventListener('click', this.onClick, true);
    }

    stopRotation() {
      if (this.timer !== null) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    updateCounter() {
      if (this.counter) this.counter.textContent = String(this.index + 1);
    }

    showImage(index, animated) {
      this.index = index;
      this.updateCounter();
      const left = this.clientWidth * index;
      this.scrollTo({ left, behavior: animated ? 'smooth' : 'auto' });
    }
  }

  customElements.define('ravin-grid-gallery', RavinGridGallery);
})();
